import gql from "graphql-tag";

export const MY_CAFETERIA_SUBSCRIPTION = gql`
  subscription cafeteriaSubscription {
    cafeteriaSubscription
  }
`;

export default MY_CAFETERIA_SUBSCRIPTION;
